import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

const selectSoldInformationsState = (state: RootState) =>
  state.soldInformations;

export const selectSoldInformations = createSelector(
  selectSoldInformationsState,
  (soldInformationsState) => soldInformationsState.soldInformations
);
